import { defineComponent as _defineComponent } from 'vue'
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import InquiryFormEn from '@/views/pages/enContact/InquiryFormEn.vue';
import sharedMessages from '@/lib/shared-messages';

import { useInquiryComposable } from '@/composables/useInquiryEn';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnContactPage',
  setup(__props) {

const {
  isValidForm,
  isLoading,
  firstName,
  lastName,
  middleName,
  phone,
  department,
  position,
  companyName,
  email,
  submit,
} = useInquiryComposable();

return { __sfc: true,isValidForm, isLoading, firstName, lastName, middleName, phone, department, position, companyName, email, submit, BaseButtonSubmit, BaseFormCard, InquiryFormEn, sharedMessages }
}

})